import React, {PropTypes} from 'react';
import {Paper, MenuItem, IconButton} from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import {Field, reduxForm} from 'redux-form';
import IntlPolyfill from 'intl';
import 'intl/locale-data/jsonp/fr';
import {Link} from 'react-router';

import CloseIcon from 'material-ui/svg-icons/navigation/close';

import {
    white
} from 'material-ui/styles/colors';

import {
    DatePicker,
    TextField,
    SelectField
} from 'redux-form-material-ui'

const DateTimeFormat = IntlPolyfill.DateTimeFormat;

const NewProjectForm = ({handleSubmit, pristine, reset, submitting, errors, projectStates}) => {
    if(projectStates.length==0) return (<div>Loading</div>);
    const closeButtonStyle = {
        position: 'absolute',
        right: 10,
        top: 10,
        color: 'white'
    };
    const projectStatesList = projectStates.map(state => (<MenuItem key={state.id} value={state.id} primaryText={state.name}/>));
    return (
        <div className="overlay">
            <Paper className="overlay-box">
                <div style={{padding: 10, width: '100%'}}>
                    <div className="popinTitle">
                        <h3 style={{margin: 0}}>Nouveau Projet</h3>
                        <Link to="/project">
                            <IconButton style={closeButtonStyle}>
                                <CloseIcon color={white}/>
                            </IconButton>
                        </Link>
                    </div>
                    <form onSubmit={handleSubmit} autoComplete="false">
                            <Field
                                name="name"
                                component={TextField}
                                hintText="Nom"
                                floatingLabelFixed
                                floatingLabelText="Nom"
                                errorText={errors && errors.name && errors.name[0]}
                                style={{width: '100%'}}/>
                            <Field
                                name="state"
                                component={SelectField}
                                hintText="Statut"
                                floatingLabelFixed
                                floatingLabelText="Statut"
                                errorText={errors && errors.state && errors.state[0]}
                                style={{width: '100%'}}>
                                {projectStatesList}
                            </Field>
                            <Field
                                name="note"
                                component={TextField}
                                hintText="Notes"
                                floatingLabelFixed
                                floatingLabelText="Notes"
                                style={{width: '100%'}}
                                multiLine={true}
                                rows={2}/>
                            <Field name="preview_date"
                                   value={null}
                                   component={DatePicker}
                                   DateTimeFormat={DateTimeFormat}
                                   hintText="Date de la preview"
                                   floatingLabelFixed
                                   floatingLabelText="Date de la preview"
                                   format={null} locale="fr"/>
                            <Field name="deploy_date"
                                   value={null}
                                   component={DatePicker}
                                   DateTimeFormat={DateTimeFormat}
                                   hintText="Date de la MEL"
                                   floatingLabelFixed
                                   floatingLabelText="Date de la MEL"
                                   format={null} locale="fr"/>
                        <div style={{display: 'inline-block', width: '100%'}}>
                            <RaisedButton type="submit" label="Ajouter" primary
                                          disabled={pristine || submitting}/> &nbsp;
                            <RaisedButton label="Réinitiliser" secondary disabled={pristine || submitting}
                                          onClick={reset}/>
                        </div>
                    </form>
                </div>
            </Paper>
        </div>
    );
};

export default reduxForm({form: 'newProjectForm'})(NewProjectForm)


/** WEBPACK FOOTER **
 ** ./src/components/ProjectManager/NewProjectForm.js
 **/